import { Map } from "schemas/functions";
import { routes } from "schemas/routes";

export enum ProOnboardingStep {
  welcome = "welcome",
  about = "about",
  templates = "templates",
  campaigns = "campaigns",
  complete = "complete",
}

export const DefaultProOnboardingSteps = [
  ProOnboardingStep.welcome,
  ProOnboardingStep.about,
  ProOnboardingStep.templates,
  ProOnboardingStep.campaigns,
  ProOnboardingStep.complete,
];

export const StepToRoute: Record<ProOnboardingStep, string> = {
  [ProOnboardingStep.welcome]: routes.onboardingProWelcome,
  [ProOnboardingStep.about]: routes.onboardingProAbout,
  [ProOnboardingStep.templates]: routes.onboardingProTemplates,
  [ProOnboardingStep.campaigns]: routes.onboardingProCampaigns,
  [ProOnboardingStep.complete]: routes.onboardingProComplete,
};

export const DefaultProOnboardingStepInfo: Map = {
  [ProOnboardingStep.about]: {
    name: "About",
    time: "2-3",
  },
  [ProOnboardingStep.templates]: {
    name: "Templates",
    time: "1-2",
  },
  [ProOnboardingStep.campaigns]: {
    name: "Campaigns",
    time: "2-3",
  },
};
